import { LiveKitRoom } from "@common/livekit/LiveKitRoom"
import "@livekit/components-styles"
import React from "react"
import { Dimensions } from "react-native"
import { connect } from "react-redux"
import PrecallDeviceSync from "./components/PrecallDeviceSync"
import { CONNECT_OPTIONS, ROOM_OPTIONS } from "../../engine/live/room/roomOptions"

const LiveKitRoomM = (props) => {
    const shouldConnect = !!props.roomData?.token

    return (
        <LiveKitRoom
            {...props}
            token={props.roomData?.token}
            video={props.roomData?.video && !props.isVideoMuted}
            // Un micro tenu par le live de l'élève ne s'ouvre pas à la connexion (`liveKitRoom.microphoneHeld`).
            audio={props.roomData?.audio && !props.microphoneHeld}
            connect={shouldConnect}
            serverUrl={props.roomData?.serverUrl}
            options={ROOM_OPTIONS}
            connectOptions={CONNECT_OPTIONS}
            data-lk-theme="default"
            style={{
                height: "100%",
                width: Dimensions.get("window").width,
            }}
            onError={(error) => {
                console.error("LiveKitRoomM error", error)
            }}
            onMediaDeviceFailure={(error) => {
                console.error("LiveKitRoomM onMediaDeviceFailure", error)
            }}
            onEncryptionError={(error) => {
                console.error("LiveKitRoomM onEncryptionError", error)
            }}
        >
            {/* Doit vivre SOUS le fournisseur de contexte : c'est la seule
                façon d'atteindre la room, et donc de lui appliquer le
                périphérique choisi au test d'entrée. */}
            <PrecallDeviceSync />
            {props.children}
        </LiveKitRoom>
    )
}
const mapStateToProps = (state) => {
    return {
        roomData: state.liveKitRoom?.roomData,
        microphoneHeld: state.liveKitRoom?.microphoneHeld === true,
        isVideoMuted: state.liveMode?.isVideoMuted,
    }
}

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(LiveKitRoomM)
